import React from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import AdminGoLauncherApplicationsPage from "./pages/Applications";
import AdminGoLauncherCategoriesPage from "./pages/Categories";

const AdminGoLauncherPage = (props: RouteComponentProps) => {
	return (
		<Switch>
			<Route path={`${props.match.url}/applications`} component={AdminGoLauncherApplicationsPage} />
			<Route path={`${props.match.url}/categories`} component={AdminGoLauncherCategoriesPage} />
			<Redirect from={props.match.url} to={`${props.match.url}/applications`} />
		</Switch>
	);
};

export default AdminGoLauncherPage;
